import { sqlQuery } from '@/shared/helpers/api.ts';
import { http } from '@/shared/httpWrapper';

export type ClientDependencyRow = {
    Kind: 'Library' | 'Attribute';
    Client: string;
    UserId: string;
    AccessMechanism: string | null;
    Attribute: string | null;
    FirstSeenDate: string;
    LastConfirmedDate: string;
};

export type ClientDependency = {
    userId: string;
    client: string;
    accessMechanisms: string[];
    attributes: string[];
    firstSeenDate: string;
    lastConfirmedDate: string;
};

export async function loadLibraryClientDependencies(libraryName: string): Promise<ClientDependencyRow[]> {
    const query = `
        SELECT Kind, Client, UserId, AccessMechanism, Attribute, FirstSeenDate, LastConfirmedDate
        FROM _Dependency
        WHERE Library = @library
        ORDER BY Client, Attribute`;

    const response = await sqlQuery(http, { query, arguments: { library: libraryName } });
    return response.data as ClientDependencyRow[];
}

export function groupClientDependencies(rows: ClientDependencyRow[]): ClientDependency[] {
    const groups = new Map<string, ClientDependency>();
    for (const row of rows) {
        let group = groups.get(row.UserId);
        if (!group) {
            group = {
                userId: row.UserId,
                client: row.Client,
                accessMechanisms: [],
                attributes: [],
                firstSeenDate: row.FirstSeenDate,
                lastConfirmedDate: row.LastConfirmedDate
            };
            groups.set(row.UserId, group);
        }
        if (row.AccessMechanism && !group.accessMechanisms.includes(row.AccessMechanism))
            group.accessMechanisms.push(row.AccessMechanism);
        if (row.Kind === 'Attribute' && row.Attribute && !group.attributes.includes(row.Attribute))
            group.attributes.push(row.Attribute);
        if (row.FirstSeenDate < group.firstSeenDate)
            group.firstSeenDate = row.FirstSeenDate;
        if (row.LastConfirmedDate > group.lastConfirmedDate)
            group.lastConfirmedDate = row.LastConfirmedDate;
    }
    return [...groups.values()].sort((a, b) => a.client.localeCompare(b.client));
}
